export const createIntersectionObserver = (
  callback: (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => void,
  options?: IntersectionObserverInit,
) => {
  const observer = new IntersectionObserver(callback, {
    rootMargin: '0px',
    threshold: 0,
    ...options,
  });

  return {
    observer,
    register: (element: Element) => {
      observer.observe(element);
      return () => observer.unobserve(element);
    },
  };
};
